module.exports = __webpack_public_path__ + "img/dd2.75861d73.jpg";